import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import seamlessData from '../../../Images/seamless_Data.png';
import Feild_Mapping from '../../../Images/Feild_Mapping.png';

const SeamlessData = () => {
  return (
    <>
      <Box
        sx={{
          width: '100%',
          py: { xs: 4, md: 8 },
          px: { xs: 2, md: 4 },
          backgroundColor: '#ffffff',
          minHeight: '60vh',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 4, md: 8 },
        }}
      >
        {/* Left Content Section */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          style={{
            flex: 1,
            maxWidth: '600px',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3.0rem' },
                color: '#383838',
                mb: 3,
                letterSpacing: '-0.02em',
                lineHeight: 1.2,
              }}
            >
              Seamless Data Integration
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: '#383838',
                fontSize: { xs: '1rem', md: '1rem' },
                lineHeight: 1.6,
                fontWeight: 400,
                maxWidth: { xs: '100%', md: '450px' },
              }}
            >
              Connect, extract, and unify data from your most-used apps and
              databases with ease. SkyShift simplifies data consolidation — no
              engineering bottlenecks required.
            </Typography>
          </Box>
        </motion.div>

        {/* Right Image Section */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
          style={{
            flex: 1,
            maxWidth: '600px',
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              minHeight: { xs: 200, md: 340 },
              background: `url(${seamlessData}) lightgray 0px -3.167px / 100% 121.488% no-repeat`,
              boxShadow:
                '0 25px 50px -12px rgba(0,0,0,0.25), 0 0 15px 0 rgba(0,0,0,0.07)',
              borderRadius: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: { xs: 1, md: 2 },
            }}
          />
        </motion.div>
      </Box>

      {/* Automated Workflows Section */}
      <Box
        sx={{
          width: '100%',
          py: { xs: 4, md: 8 },
          px: { xs: 2, md: 4 },
          backgroundColor: '#ffffff',
          minHeight: '60vh',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row-reverse' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 4, md: 24 },
        }}
      >
        {/* Right Content Section (now on the right) */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          style={{
            flex: 1,
            maxWidth: '600px',
            textAlign: { xs: 'center', md: 'left' },
          }}
          // Add margin for consistent gap
          sx={{ mx: { md: 4 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3.0rem' },
                color: '#383838',
                mb: 3,
                letterSpacing: '-0.02em',
                lineHeight: 1.2,
              }}
            >
              Automated Workflows
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: '#383838',
                fontSize: { xs: '1rem', md: '1rem' },
                lineHeight: 1.6,
                fontWeight: 400,
                maxWidth: { xs: '100%', md: '450px' },
              }}
            >
              Set up intelligent automation with flexible scheduling, event
              triggers, and retry logic. Keep your pipelines running smoothly
              without constant supervision.
            </Typography>
          </Box>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
          style={{
            flex: 1,
            maxWidth: '600px',
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              minHeight: { xs: 200, md: 340 },
              background: `url(${Feild_Mapping}) lightgray 0px -3.167px / 100% 121.488% no-repeat`,
              boxShadow:
                '0 25px 50px -12px rgba(0,0,0,0.25), 0 0 15px 0 rgba(0,0,0,0.07)',
              borderRadius: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: { xs: 1, md: 2 },
            }}
          />
        </motion.div>
      </Box>
    </>
  );
};

export default SeamlessData;
